<template>
  <div class="admin-page">
    <header class="admin-header">
      <div>
        <p class="eyebrow">USER OPERATIONS</p>
        <h1>用户信息管理</h1>
        <p>查看平台注册用户，调整基础资料、信誉分和账号状态。注销会禁用账号，不直接物理删除数据。</p>
      </div>
      <button class="primary-btn" @click="fetchUsers">刷新用户</button>
    </header>

    <section class="filter-card">
      <el-input v-model.trim="filters.keyword" clearable placeholder="搜索昵称 / 邮箱 / 手机号" @keyup.enter="fetchUsers"></el-input>
      <el-select v-model="filters.status" clearable placeholder="账号状态" @change="fetchUsers">
        <el-option label="启用" :value="1"></el-option>
        <el-option label="已注销/禁用" :value="0"></el-option>
      </el-select>
      <button class="primary-btn" @click="fetchUsers">查询</button>
    </section>

    <section class="table-card">
      <el-table v-loading="loading" :data="users">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="username" label="昵称" min-width="150"></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="210"></el-table-column>
        <el-table-column label="手机号" min-width="180">
          <template #default="{ row }">{{ row.phoneCountryCode || '' }} {{ row.phone || '' }}</template>
        </el-table-column>
        <el-table-column prop="reputationScore" label="信誉分" width="100"></el-table-column>
        <el-table-column label="状态" width="110">
          <template #default="{ row }">
            <el-tag :type="row.status === 0 ? 'danger' : 'success'">{{ row.status === 0 ? '已注销' : '启用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210">
          <template #default="{ row }">
            <el-button size="mini" @click="openEdit(row)">修改</el-button>
            <el-button v-if="row.status !== 0" size="mini" type="danger" @click="disableUser(row)">注销</el-button>
            <el-button v-else size="mini" type="success" @click="enableUser(row)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <el-dialog title="修改用户信息" v-model="editVisible" width="560px" append-to-body>
      <el-form v-if="editForm" label-position="top">
        <el-form-item label="昵称">
          <el-input v-model.trim="editForm.username"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model.trim="editForm.email"></el-input>
        </el-form-item>
        <div class="form-grid">
          <el-form-item label="国际区号">
            <el-input v-model.trim="editForm.phoneCountryCode"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model.trim="editForm.phone"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="信誉分">
          <el-input-number v-model="editForm.reputationScore" :min="0" :max="100" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="账号状态">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">注销/禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveUser">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { disableAdminUser, enableAdminUser, getAdminUsers, updateAdminUser } from '../api/market'

export default {
  name: 'AdminUsers',
  data() {
    return {
      loading: false,
      saving: false,
      users: [],
      editVisible: false,
      editForm: null,
      filters: {
        keyword: '',
        status: ''
      }
    }
  },
  created() {
    this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      this.loading = true
      try {
        const response = await getAdminUsers({
          keyword: this.filters.keyword || undefined,
          status: this.filters.status === '' ? undefined : this.filters.status
        })
        if (response.data.code !== 200) {
          this.$message.error(response.data.msg || '用户列表加载失败')
          return
        }
        this.users = response.data.data || []
      } catch (error) {
        this.$message.error('用户列表请求失败')
      } finally {
        this.loading = false
      }
    },
    openEdit(user) {
      this.editForm = { ...user }
      this.editVisible = true
    },
    async saveUser() {
      if (!this.editForm) return
      this.saving = true
      try {
        const response = await updateAdminUser(this.editForm.id, this.editForm)
        if (response.data.code !== 200) {
          this.$message.error(response.data.msg || '用户保存失败')
          return
        }
        this.$message.success('用户信息已更新')
        this.editVisible = false
        this.fetchUsers()
      } catch (error) {
        this.$message.error('用户保存请求失败')
      } finally {
        this.saving = false
      }
    },
    async disableUser(user) {
      await this.$confirm(`确认注销用户「${user.username || user.email || user.id}」吗？`, '注销用户', {
        confirmButtonText: '确认注销',
        cancelButtonText: '取消',
        type: 'warning'
      })
      await this.runAction(() => disableAdminUser(user.id), '用户已注销/禁用')
    },
    async enableUser(user) {
      await this.runAction(() => enableAdminUser(user.id), '用户已启用')
    },
    async runAction(request, successText) {
      try {
        const response = await request()
        if (response.data.code !== 200) {
          this.$message.error(response.data.msg || '操作失败')
          return
        }
        this.$message.success(successText)
        this.fetchUsers()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('操作失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.admin-page {
  min-height: 100vh;
  padding: 28px;
  color: #f6fbff;
}

.admin-header,
.filter-card,
.table-card {
  border: 1px solid rgba(143, 241, 199, 0.14);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.06);
}

.admin-header {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 24px;
  margin-bottom: 18px;
}

.eyebrow {
  margin: 0 0 8px;
  color: #8ff1c7;
  font-size: 12px;
  letter-spacing: 0.18em;
}

.admin-header h1 {
  margin: 0;
  font-size: 30px;
}

.admin-header p {
  margin: 8px 0 0;
  color: rgba(246, 251, 255, 0.66);
}

.filter-card {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 180px 120px;
  gap: 12px;
  padding: 16px;
  margin-bottom: 18px;
}

.table-card {
  padding: 16px;
}

.primary-btn {
  height: 40px;
  border: none;
  border-radius: 999px;
  color: #03101d;
  font-weight: 800;
  cursor: pointer;
  background: linear-gradient(135deg, #8ff1c7, #ffd08a);
}

.form-grid {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 12px;
}

@media (max-width: 760px) {
  .admin-header,
  .filter-card {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
}
</style>
